import {WP_PAGE_ACF_FC_Layouts} from "../../enums/wp-page-acf-fc-layouts";

export class PageBaseSection{
  acf_fc_layout : WP_PAGE_ACF_FC_Layouts;
  title : string;
  introduction : string;
  active = true;
}
